module.exports = {
      id: "shorts-outline-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#shorts-outline",
      toString: function () {
        return this.url;
      }
    }